import { useEffect, useState } from "react";
import Alert from "@mui/material/Alert";
import Divider from "@mui/material/Divider";
import NoFoto from "../assets/noFoto.jpg";
import { RUTA_IMG } from "../componentes/config.js";
import Spinner from "react-bootstrap/Spinner";
import { sqlAdjunto } from "../componentes/api.js";

function CambiarFoto(props) {
  const [actualizando, setActualizando] = useState(false);
  /*** Para muestra preliminar de las Imágenes ***** */
  const [file, setFile] = useState(null);
  const [fileDataURL, setFileDataURL] = useState();

  useEffect(() => {
    setActualizando(true);
    if (props.Foto !== "") {
      setFileDataURL(RUTA_IMG + "fotos/" + props.Foto);
    } else {
      setFileDataURL(NoFoto);
    }
    setActualizando(false);
  }, [props.Foto]);

  const handleChange = (e) => {
    setFile(e.files[0]);
    let fileReader;
    if (e.files[0]) {
      fileReader = new FileReader();
      fileReader.onload = (e) => {
        const { result } = e.target;
        if (result) {
          setFileDataURL(result);
        }
      };
      fileReader.readAsDataURL(e.files[0]);
    }
  };

  const grabar = async (event) => {
    event.preventDefault();
    setActualizando(true);
    if (file === null) {
      setActualizando(false);
      props.mostrarMsg(["Por favor seleccione una Foto para subir"]);
    } else {
      try {
        /** Formateo los datos que enviaré */
        const formData = new FormData();
        formData.append("Ruta", props.Ruta);
        formData.append("Tabla", props.Tabla);
        formData.append("Campo", props.Campo);
        formData.append("Id", props.Id);
        // formData.append("Img", props.Img);
        formData.append("image", file);

        //  const response = await actualizarImagen(formData)
        const response = await sqlAdjunto("setImagen", formData);
        props.actualizarCampoPerfil(props.Campo, response.data);
        setActualizando(false);
        props.mostrarMsg(["Felicidades!!", "Foto actualizada"]);
      } catch (error) {
        setActualizando(false);
        alert("ERROR", "Ocurrio un error al Actualizar la imagen", error);
      }
    }
  };

  return (
    <div className="container mb-3">
      <div className="row card shadow mb-3 mt-3" style={{ width: 600 }}>
        <Alert severity="success">
          <h1 className="text-muted mt-3 mb-3">
            <strong>Cambiar Foto de Perfil</strong>
          </h1>
          Por favor seleccione un archivo para subir al servidor!
        </Alert>

        <div className="mt-3 mb-3 text-center">
          <img
            style={{ width: "300px", height: "300px", borderRadius: 200 }}
            src={fileDataURL}
            alt={"Imagen"}
            className="img-fluid card-img-top img-centered"
          />
        </div>

        <div className="row mb-3">
          <form method="post" encType="multipart/form-data">
            <input
              className="form-control"
              type="file"
              name="archivo"
              id="archivo"
              //accept={datosAnexo.formato}
              onChange={(e) => handleChange(e.target)} //multiple
            />
            <Divider light className="mt-1 mb-1" />
            <button
              className="btn btn-primary"
              onClick={(event) => grabar(event)}
            >
              Actualizar Foto
            </button>
            {actualizando === true && (
              <div>
                <Spinner
                  animation="grow"
                  variant="primary"
                  size="xl"
                  role="status"
                ></Spinner>
                <span className="visually">
                  Un momento por favor, estamos actualizando su imagen...
                </span>
              </div>
            )}
          </form>
        </div>
      </div>
    </div>
  );
}
export default CambiarFoto;
